import axios from "axios";
// const API_URL = process.env.REACT_APP_API_URL
const API_URL = process.env.REACT_APP_ADMIN_API_URL
const API_URL_V1 = process.env.REACT_APP_V1_API_URL


const getHeader = () => {
  let user: any = localStorage.getItem("token");

  return user && { Authorization: user };
};

export default class Http {
  static get(url: string, params?: any) {
    return new Promise((resolve, reject) => {
      let token = getHeader();
      axios({
        method: "get",
        url: `${API_URL}/${url}`,
        headers: token,
        params: params,
      })
        .then(function (response: any) {
          resolve(response.data);
        })
        .catch(function (error: any) {
          reject(error);
        });
    });
  }

  static post(url: string, body: any) {
    return new Promise(async (resolve, reject) => {
      let token = getHeader();
      axios({
        method: "post",
        url: `${API_URL}/${url}`,
        data: body,
        headers: token,
      })
        .then(function (response: any) {
          resolve(response.data);
        })
        .catch(function (error: any) {
          reject(error);
        });
    });
  }

  static put(url: string, body: any) {
    return new Promise((resolve, reject) => {
      let token = getHeader();
      axios({
        method: "put",
        url: `${API_URL}/${url}`,
        data: body,
        headers: token,
      })
        .then(function (response: any) {
          resolve(response.data);
        })
        .catch(function (error: any) {
          reject(error);
        });
    });
  }

  static delete(url: string) {
    return new Promise((resolve, reject) => {
      let token = getHeader();
      axios({
        method: "delete",
        url: `${API_URL}/${url}`,
        headers: token,
      })
        .then(function (response) {
          if (response.data && (response.data.success || response.data.statusCode === 200)) {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch(function (error) {
          reject(error.response.data);
        });
    });
  }

  static masterGet(url: string) {
    return new Promise((resolve, reject) => {
      axios({ method: "get", url: `${API_URL_V1}/${url}` }).then((response) => {
        if (response.data && (response.data.success || response.data.statusCode === 200)) {
          resolve(response.data);
        } else {
          reject(response.data);
        }
      }).catch((error) => {
        reject(error.response.data);
      });
    });
  }
}
